import { ReactNode } from 'react'

import { Masthead } from '@/ui/Masthead'

interface Props {
  children: ReactNode
  onOpenPalette?: () => void
}

export function AppShell({ children, onOpenPalette }: Props) {
  return (
    <div className="flex flex-col h-screen bg-ink grain-overlay">
      <Masthead onOpenPalette={onOpenPalette} />
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  )
}
